<section class="w-full flex flex-wrap pb-10">
  <article class="w-full flex flex-wrap">
    <app-header class="sticky top-0 z-30 bg-white dark:bg-gray-900 shadow-sm" class="w-full flex items-center" [_Config]="headerConfig"> </app-header>

    <!-- ? Challenges Tabs -->
    <div class="w-full">
      <div class="w-full mt-4 flex justify-around items-center px-2 tab-border border-b border-gray-100 dark:border-gray-800">
        <button
          class="w-1/2 sm:w-5/12 max-md:px-0 rounded-0 btn-md pb-3"
          (click)="activeTab(1)"
          [ngClass]="{
            'active-tab border-b border-green-500 dark:border-green-400': activeState === 1,
          }">
          <span class="w-full text-gray-400 text-sm md:text-base font-medium" [ngClass]="{ 'text-gray-900': activeState === 1 }"> چالش‌های من </span>
        </button>
        <button
          class="w-1/2 sm:w-5/12 max-md:!px-0 rounded-0 btn-md pb-3"
          (click)="activeTab(2)"
          [ngClass]="{
            'active-tab border-b border-green-500 dark:border-green-400': activeState === 2,
          }">
          <span class="w-full text-gray-400 text-sm md:text-base font-medium" [ngClass]="{ 'text-gray-900': activeState === 2 }"> همۀ چالش‌های کتابخوانی </span>
        </button>
      </div>
    </div>

    <!-- ? Tabs Content -->
    <div class="w-full flex flex-wrap items-start mt-4 px-4 pb-8">
      <!-- ? My Challenges Tab -->
      <ng-container *ngIf="activeState === 1">
        <!-- ? Completed Challenges -->
        @if (isLoadingMyChallenge) {
          <div class="w-full p-4">
            <ngx-skeleton-loader [theme]="{ height: '170px', width: '100%' }"> </ngx-skeleton-loader>
          </div>
        } @else {
          <div class="w-full p-4 flex items-center bg-gray-100 dark:bg-gray-800 rounded-lg cursor-pointer">
            <div class="w-16 h-16 rounded-xl flex items-center justify-center">
              <img class="avatar-lg min-h-16 min-w-16 object-fill" loading="lazy" src="https://cloud.behkhaan.ir/assets/images/challenge/default-badge.svg" />
            </div>

            <div class="flex-1 flex-wrap pr-4" [routerLink]="[routes.challenges_completed, currentUser?.id]">
              <div class="w-full flex items-center justify-between">
                <p class="text-sm md:text-base font-medium text-gray-900">چالش‌های تمام شده</p>
                <span class="icon text-sm text-gray-400 chevron-left-regular"></span>
              </div>

              <div class="w-full mt-2">
                <p class="text-xs md:text-sm text-gray-600">
                  {{ challengeStatistic.scoresSum }}
                  امتیاز از چالش‌های انجام شده
                </p>
              </div>
            </div>
          </div>

          <!-- ? Active Challenges -->
          <ng-container *ngIf="activeChallenges?.length >= 1">
            <div class="w-full mt-4">
              <p class="text-sm md:text-base font-medium text-gray-900">چالش‌های فعال</p>
            </div>

            <!-- ? Mobile view -->
            <div class="w-full block sm:hidden">
              <ng-container *ngFor="let challenge of activeChallenges">
                <div class="flex items-start justify-between relative text-sm font-medium mt-4 sm:mt-12 bg-gray-100 dark:bg-gray-800 rounded-md shadow-sm">
                  <app-challenge-item
                    [inChallengesPage]="true"
                    [challenges]="challenge | challengeItem: routes.challenge_detail : challenge.id : mobileActiveChallenge : selectionStatus.CurrentlySelected">
                  </app-challenge-item>
                  <span class="icon text-sm text-gray-400 chevron-left-regular absolute top-4 left-4"></span>
                </div>
              </ng-container>
            </div>

            <!-- ? Desktop view -->
            <div class="w-full hidden sm:flex">
              <swiper-container class="w-full py-8 flex" slides-per-view="auto" watch-overflow="true" navigation="true" observer="true" observe-parents="true" lazy="true">
                @for (challenge of activeChallenges; track $index) {
                  <swiper-slide class="max-sm:w-[305px] sm:w-[400px] md:!w-[500px] ml-4 !py-8">
                    <app-challenge-item
                      [inChallengesPage]="true"
                      class="w-full h-full rounded-lg bg-gray-100 dark:bg-gray-800 ml-4 flex"
                      [challenges]="challenge | challengeItem: routes.challenge_detail : challenge?.userChallenges[0]?.id : desktopActiveChallenge : selectionStatus?.CurrentlySelected">
                    </app-challenge-item>
                  </swiper-slide>
                }
              </swiper-container>

            </div>
          </ng-container>
        }
      </ng-container>

      <!-- ? All Challenges Tab -->
      <ng-container *ngIf="activeState === 2">
        <ng-container *ngIf="!loadingChallenges; else skeletonTemplate">
          <div class="w-full flex flex-wrap">
            <ng-container *ngFor="let challenges of challengesWithLevel">
              <!-- ? Title -->
              <div class="w-full md:mb-2">
                <p class="text-sm md:text-base font-medium text-gray-900">
                  {{ challenges.title }}
                </p>
              </div>

              <!-- ? Desktop view -->

              <swiper-container class="!w-full !py-8 !hidden sm:!flex" slides-per-view="auto" watch-overflow="true" navigation="true" observer="true" observe-parents="true" lazy="true">
                @for (challenge of challenges.items; track $index) {
                  <swiper-slide class="max-sm:w-full sm:w-[200px] md:!w-[274px] ml-4 !py-8">
                  <app-challenge-item
                    [inChallengesPage]="true"
                    class="flex w-full h-full rounded-lg bg-gray-100 dark:bg-gray-800 shadow-sm cursor-pointer"
                    [challenges]="challenge | challengeItem: routes.challenge_setting : challenge.id : allChallengeConfig : challenge.selectionStatus"
                    (pickChallenge)="onjoinChallenge($event)"
                    [joinLoading]="joinLoadingMap[challenge?.id]">
                  </app-challenge-item>
                  </swiper-slide>
                }
              </swiper-container>


              <!-- ? Mobile view -->
              <div class="h-full py-4 md:py-2 flex sm:hidden flex-wrap">
                <ng-container *ngFor="let challenge of challenges.items">
                  <div class="flex w-full items-start justify-between text-sm font-medium rounded-lg mb-4">
                    <app-challenge-item
                      class="bg-gray-100 dark:bg-gray-800 rounded-md shadow-sm w-full"
                      [inChallengesPage]="true"
                      [challenges]="challenge | challengeItem: routes.challenge_detail : challenge.id : allChallengeConfig : challenge.selectionStatus"
                      (pickChallenge)="onjoinChallenge($event)">
                    </app-challenge-item>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </article>
</section>

<!-- ? Skeleton -->
<ng-template #skeletonTemplate>
  <div class="w-full activity-container px-2">
    <!-- ? First Level Challenges -->
    <div class="w-full mt-4">
      <ngx-skeleton-loader class="flex" [theme]="{ height: '252px', width: '100%' }"> </ngx-skeleton-loader>
    </div>

    <!-- ? Second Level Challenges -->
    <div class="w-full mt-4">
      <ngx-skeleton-loader class="flex" [theme]="{ height: '252px', width: '100%' }"> </ngx-skeleton-loader>
    </div>

    <!-- ? Second Level Challenges -->
    <div class="w-full mt-4">
      <ngx-skeleton-loader class="flex" [theme]="{ height: '252px', width: '100%' }"> </ngx-skeleton-loader>
    </div>
  </div>
</ng-template>
